const initialState = {
  fetching: false,
  fetched: false,
  deleting: false,
  deleted: false,
  saving: false,
  currentTreeId: null,
  openDeleteConfirm: false,
  items: [],
  error: null,
  nbResult: 0,
  filterNotIn: []
};
export const treesReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_TREES_LIST": {
      return initialState;
    }
    case "FETCH_TREES_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_TREES_FULFILLED": {
      const { data, nbResult } = action.payload.data;

      let result = data ? data : [];

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: result,
        nbResult: nbResult
      };
    }
    case "FETCH_TREES_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SAVE_TREE_PENDING": {
      return {
        ...state,
        saved: false,
        saving: true
      };
    }
    case "SAVE_TREE_FULFILLED": {
      const { data } = action.payload.data;
      let result = data ? data : [];

      return {
        ...state,
        saving: false,
        items:
          state.currentTreeId === 0 ? [...state.items, result] : state.items,
        currentTreeId: null,
        error: null
      };
    }
    case "SAVE_TREE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }

    case "DELETE_TREE_PENDING": {
      return {
        ...state,
        deleting: true
      };
    }
    case "DELETE_TREE_FULFILLED": {
      return {
        ...state,
        deleting: false,
        openDeleteConfirm: false,
        currentTreeId: null,
        items: state.items.filter(item => item.id !== state.currentTreeId),
        error: null
      };
    }
    case "DELETE_TREE_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        deleting: false,
        error
      };
    }

    case "SET_CURRENT_TREE_ID": {
      return {
        ...state,
        currentTreeId: action.payload
      };
    }

    case "SET_FILTER_NOT_IN": {
      return {
        ...state,
        filterNotIn: action.payload
      };
    }

    case "SET_OPEN_DELETE_CONFIRM": {
      return {
        ...state,
        openDeleteConfirm: action.payload
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tree.js